<template>
  <el-dialog
    ref="dialog"
    title="导出Excel"
    size="large"
    style="min-width:1280px">
    <div class="h-400" style="overflow-y: scroll">
      <div class="p-b-30 m-t-20 m-l-50 m-b-30 bor-b-ccc">
        <span class="fw-b m-r-10">导出表头选择</span>
        <el-checkbox :true-label="1" :false-label="0" v-model="chooseAll">全选</el-checkbox>
      </div>
      <div class="m-l-50">
        <el-checkbox-group v-model="exportColIndexs">
          <el-checkbox 
            style="white-space:normal"
            v-for="(option, index) in source.column"
            :label="index"
            class="m-l-0 w-160 m-r-30 m-b-20 text-overflow"
            :title="option.show_name">
            {{ option.show_name }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="comfirmExport">确 定</el-button>
    </span>
  </el-dialog>
</template>

<style scoped>

</style>

<script>
  import http from '../../../../assets/js/http'
  export default {
    props: {
      source: {
        type: Object,
        default() {
          return {
            exportCols: [], // 所选导出列
            url: '',
            postData: {},
            column: []
          }
        }
      },
      dealId: {
        default() {
          return ''
        }
      }
    },
    data() {
      return {
        exportColIndexs: [],
        chooseAll: 0,
        arrChange: false
      }
    },
    methods: {
      openDialog() {
        this.$refs.dialog.open()
      },
      closeDialog() {
        this.$refs.dialog.close()
      },
      comfirmExport() {
        this.source.exportCols = this.getColName()
        this.doExport()
        this.closeDialog()
      },
      getColName() {
        let arr = []
        _(this.exportColIndexs).forEach((res) => {
          arr.push(this.source.column[res])
        })
        return arr
      },
      doExport() {
        let postData = _.cloneDeep(this.source.postData)
        postData.column = this.source.exportCols
        postData.list_deal_id = this.dealId
        let newWin = window.open('', '_blank')
        this.apiPost(this.source.url, postData).then((res) => {
          if (res.code == 200) {
            newWin.location = HOST + res.data
            // setTimeout(() => {
            //   newWin.close()
            // }, 500)
          } else {
            _g.dealError(this, res)
          }
        })
      }
    },
    watch: {
      'chooseAll' () {
        if (this.chooseAll == 1) {
          this.exportColIndexs = []
          _(this.source.column).forEach((res, index) => {
            this.exportColIndexs.push(index)
          })
        } else {
          if (this.exportColIndexs.length == this.source.column.length) {
            this.exportColIndexs = []
          }
        }
      },
      'exportColIndexs' () {
        if (this.exportColIndexs.length == this.source.column.length) {
          this.chooseAll = 1
        } else {
          this.chooseAll = 0
        }
      }
    },
    mixins: [http]
  }
</script>
<style scoped>
  .el-checkbox+.el-checkbox {
    margin-left: 0;
  }
</style>


// WEBPACK FOOTER //
// exportDeal.vue?3c5b8cdc